import { render, staticRenderFns } from "./EditHeaderTitle.vue?vue&type=template&id=5d876236&"
import script from "./EditHeaderTitle.vue?vue&type=script&lang=js&"
export * from "./EditHeaderTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports